<template>
  <div>
    <group>
      <selector
        title="加油方式"
        direction="rtl"
        v-model="type"
        :options="typeList"
      ></selector>
      <selector
        :title="title"
        direction="rtl"
        v-model="formData.shipId"
        :options="shipList"
      ></selector>
      <cell title="业务员">{{ formData.userName }}</cell>
      <x-input title="联系方式" v-model="formData.userPhone"></x-input>
    </group>
    <div class="button-bottom-wrap" style="display: flex;">
      <button
        class="button-bottom"
        style="background: #454545;"
        @click="reject"
      >
        拒绝
      </button>
      <button class="button-bottom" @click="submit">
        跟进
      </button>
    </div>
  </div>
</template>

<script>
import { getAdminShipList, getAdminCarList } from "@/api/ship";
import { followOrder } from "@/api/order";
import { validatePhone } from "@/utils/validate-util";
import orderMixin from "@/mixin/order";
import { mapActions } from "vuex";

export const typeOptions = [
  {
    key: "1",
    value: "个人"
  },
  {
    key: "2",
    value: "企业"
  }
];

export default {
  props: {
    id: {
      type: String
    }
  },
  data() {
    return {
      typeOptions,
      typeList: [
        {
          key: "0",
          value: "船发"
        },
        {
          key: "1",
          value: "车发"
        }
      ],
      title: "渔船编号",
      type: "0",
      shipList: [],
      formData: {
        shipId: "",
        userName: "",
        userPhone: ""
      }
    };
  },
  mixins: [orderMixin],
  watch: {
    type(val) {
      if (val == 0) {
        this.title = "渔船编号";
        this.fetchShipList();
      } else {
        this.title = "车牌号";
        this.fetchCarList();
      }
    }
  },
  created() {
    this.fetchShipList();
  },
  methods: {
    ...mapActions(["fetchOrderDetail"]),
    afterFetch() {
      this.formData.userName = this.detail.userName;
      this.formData.userPhone = this.detail.userPhone;
    },
    reject() {
      let result = confirm("确认拒绝吗？");
      if (!result) {
        return;
      }
      const params = {
        id: this.id,
        status: 0
      };
      this.$vux.loading.show({
        transition: "",
        text: "处理中"
      });
      followOrder(params)
        .then(() => {
          this.$showError("提交成功");
          this.fetchOrderDetail({ id: this.id });
          setTimeout(() => {
            this.$router.back();
          }, 1000);
        })
        .catch(e => {
          this.$showError(e);
        })
        .finally(() => {
          this.$vux.loading.hide();
        });
    },
    submit() {
      const rules = {
        shipId: "required"
        // userPhone: "required|phone"
      };

      const attrs = {
        shipId: "加油船"
        // userPhone: "联系方式"
      };

      if (!validatePhone(this.formData.userPhone)) {
        this.$showError("联系方式格式错误", "warn");
        return;
      }

      const params = {
        ...this.formData,
        status: 1,
        id: this.id
      };
      this.$validate(params, rules, attrs)
        .then(() => {
          this.$vux.loading.show({
            transition: "",
            text: "处理中"
          });
          followOrder(params)
            .then(() => {
              this.$showError("提交成功");
              this.fetchOrderDetail({ id: this.id });
              setTimeout(() => {
                this.$router.back();
              }, 1000);
            })
            .catch(e => {
              this.$showError(e);
            })
            .finally(() => {
              this.$vux.loading.hide();
            });
        })
        .catch(e => {
          this.$showError(e, "warn");
        });
    },
    fetchShipList() {
      getAdminShipList().then(res => {
        this.shipList = res.map(x => {
          return {
            key: x.id,
            value: x.shipCode
          };
        });
        if (this.shipList.length === 1) {
          this.formData.shipId = this.shipList[0].key;
        }
      });
    },
    fetchCarList() {
      getAdminCarList().then(res => {
        this.shipList = res.map(x => {
          return {
            key: x.id,
            value: x.shipCode
          };
        });
        if (this.shipList.length === 1) {
          this.formData.shipId = this.shipList[0].key;
        }
      });
    }
  }
};
</script>

<style></style>
